import { render, staticRenderFns } from "./XreportCard.vue?vue&type=template&id=13a388f8"
import script from "./XreportCard.vue?vue&type=script&lang=js"
export * from "./XreportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports